<template>
    <v-chip-group v-bind="$attrs" multiple class="ma-n4">
        <template v-for="(file, i) in value">
            <v-chip outlined large label  class="ma-4" v-bind="makeChipAttrs(file)" :close="mode == 'form'" @click:close="pull(file)" :key="i">
                <template v-if="mode == 'view'">
                    <v-icon small class="mr-4"> mdi-file </v-icon>
                </template>
                <span>{{ file.name }}</span>
            </v-chip>
        </template>
        <template v-if="mode == 'form'">
            <v-file-btn v-model="temp" tag="v-chip" outlined large label width="32" min-width="32" height="32" class="ma-4 pa-0" @input="push">
                <v-icon>mdi-plus</v-icon>
            </v-file-btn>
        </template>
    </v-chip-group>
</template>

<script>
import VFileBtn from "./v-file-btn.vue";

export default {
    components: {
        VFileBtn,
    },
    props: {
        value: { type: Array, default: () => [] },
        mode: { type: String, default: "form" },
    },
    data: () => ({
        temp: null,
    }),
    methods: {
        push() {
            if (this.temp) {
                this.$emit("input", [...this.value, this.temp]);
                this.$nextTick(() => (this.temp = null));
            }
        },
        pull(file) {
            const files = this.value.filter((item) => item != file);
            this.$emit("input", files);
        },
        makeChipAttrs(file) {
            const attrs = {};

            if (file?.url) {
                attrs.target = "_blank";
                attrs.href = file.url;
            }

            return attrs;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-chip {
        &,
        &::before {
            background: none !important;
        }
    }
}
</style>
